import { render, staticRenderFns } from "./PurchaseDetailButton.vue.html?vue&type=template&id=58610ce2&scoped=true&"
import script from "./PurchaseDetailButton.component.js?vue&type=script&lang=vueJs&"
export * from "./PurchaseDetailButton.component.js?vue&type=script&lang=vueJs&"
import style0 from "./PurchaseDetailButton.scoped.scss?vue&type=style&index=0&id=58610ce2&prod&lang=vueScss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58610ce2",
  null
  
)

export default component.exports